import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {
  getWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import swal from "sweetalert";
import Loading from "../sharedComponents/Loaders/Loading";
import { Table } from "react-bootstrap";
import ic_eyes from "../assets/images/ic_eyes.svg";
import ReactSelect from "react-select";
import {CopyToClipboard} from 'react-copy-to-clipboard';

const TransactionLog = () => {
  const { sidebar, customerData } = useContext(AppContext);
  const [logList, setLogList] = useState([]);
  const [orderId_List, setOrderId_List] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState({
    label: "",
    value: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [logData, setLogData] = useState("");

  const [deleteShow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = () => setDeleteShow(true);
  const [viewShow, setViewShow] = useState(false);
  const handleViewClose = () => setViewShow(false);
  const handleViewShow = (data) => {
    setViewShow(true);
    setLogData(data);
  };
  useEffect(() => {
    getOrderIdList();
    return () => {};
  }, []);

  useEffect(() => {
    getTransactionLogList();
  }, [selectedOrderId]);
  const getTransactionLogList = () => {
    setIsLoading(true);
    if (selectedOrderId.value !== "") {
      simpleGetCallWithErrorResponse(
          ApiConfig.TRANSACTION_LOG_LIST + selectedOrderId.value
      )
          .then((res) => {
            let data = res.json;
            setIsLoading(false);
            if (data) {
              setLogList(data);
            }
          })
          .catch((err) => {
            setIsLoading(false);
            console.log(err);
          });
    } else {
      setIsLoading(false);
      setLogList([]);
    }
  };
  const getOrderIdList = () => {
    setIsLoading(true);
    getWithAuthCallWithErrorResponse(
      ApiConfig.TRANSACTION_ORDER_ID_LIST,
      JSON.stringify({ ...customerData })
    )
      .then((res) => {
        let data = res.json;
        setIsLoading(false);
        if (data && data.length > 0) {
          setOrderId_List(data);
          setSelectedOrderId({
            ...selectedOrderId,
            label: data[0].orderId,
            value: data[0].orderId,
          });
        }
      })

      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const orderId_options = useMemo(
    () =>
      [...new Set(orderId_List.map((item) => item))].map((orderId) => {
        return { label: orderId.orderId, value: orderId.orderId };
      }),
    [orderId_List]
  );

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">TRANSACTION LOG</label>
        </div>
      </div>

      <Modal
        show={viewShow}
        onHide={handleViewClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Log Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row user-detail">
            <div className="col-md-9">
              <span>{logData}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons-modal    ">
            <button className="me-2 " type="submit" onClick={handleViewClose}>
              Cancel
            </button>
            <CopyToClipboard text={logData} onCopy={handleViewClose}>
              <button>Copy</button>
            </CopyToClipboard>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deleteShow}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 "
              type="submit"
              style={{ backgroundColor: "red" }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="table-wrapper">
        <div className="select-wrapper row">
          <Form.Group className="mb-4 col-md-3">
            <Form.Label>ORDER ID</Form.Label>
            <ReactSelect
              value={selectedOrderId}
              onChange={(e) =>
                e &&
                setSelectedOrderId({
                  ...selectedOrderId,
                  label: e.value,
                  value: e.value,
                })
              }
              options={orderId_options}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  // primary25: "#395970",
                  primary: "#395970",
                },
              })}
            />
          </Form.Group>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <Table striped hover id="TransactionLog" class="table display">
            <thead>
              <tr>
                <th>Transaction Date</th>
                <th>Steps</th>
                <th>Function Code</th>
                <th>Log Data</th>
                <th>View Log</th>
              </tr>
            </thead>

            <tbody>
              {logList?.length > 0 ? (
                logList.map((log, index) => {
                  return (
                    <tr key={log.id}>
                      <td style={{ width: "300px !important" }}>
                        {log?.createdAt}
                      </td>
                      <td>{log?.step}</td>
                      <td>{log?.funcode ? log?.funcode : "NULL"}</td>
                      <td className="">
                        <div
                          className="text-truncate m-0"
                          style={{ maxWidth: "300px", cursor: "pointer" }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="left"
                          title={log?.json}
                        >
                          {log?.json}
                        </div>
                      </td>
                      <td className="action">
                        <Link
                          to="#"
                          className="icon"
                          onClick={() => {
                            handleViewShow(log?.json);
                          }}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">
                    <p className="text-danger my-3 text-center">No Data Found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    </main>
  );
};

export default TransactionLog;
